require('angular')
require('../../../core/translation/translation-module')
require('../auth/auth-module')
require('../common-header/common-header-module')
NavigationHeaderDirective = require('./navigation-header-directive')

modules = [
  'gnp-auth'
  'gnp-translation'
]
angular.module 'gnp-navigation-header', modules
  .directive('gnpNavigationHeader', NavigationHeaderDirective)



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/navigation-header/navigation-header-module.coffee